/*
    Description: js entry point for all our sites interactions
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

// use strict
'use strict';

//imports
import "../css/main.scss";
import Search from "./inc/search";
import Subscribe from "./inc/subscribe";
import Overlay from "./inc/overlay";
import Menu from "./inc/menu";
import Cards from "./inc/cards";
import ResearchSearch from "./inc/research-search";
import Reports from "./inc/reports";
import Calculators from "./inc/calculators";
import MorePosts from "./inc/more-posts";
import Infographics from "./inc/more-infographics";
import Videos from "./inc/videos";
import Data from "./inc/data";

//DOM Ready
document.onreadystatechange = () => { 
    
    // DOM ready state complete 
    if(document.readyState == 'complete'){
        
        // --------------------------- //
        // Menu ---------------------- //
        // --------------------------- //
        // enable menu interactions
        const menu = new Menu();

        // --------------------------- //
        // Search (NAV) -------------- //
        // --------------------------- //
        // enable main menu search (NAV)
        const search = new Search();

        // -------------------------------------- //
        // search overlay ----------------------- //
        // -------------------------------------- //
        const searchOverlay = new Overlay({

            //set custom class for our modal
            modalSelector:".search__modal",

            //set class name to fire off modal
            buttonSelector:".search__molab",

            // add search title
            title:search.setTitle(),
            
            // add form to body
            body:search.setBody(),
            
            // callback
            callback:function(){

                // submit search
                search.submit();
                
            }

        });

        // --------------------------- //
        // Research Row Search ------- //
        // --------------------------- //
        // enable research search
        const researchSearch = new ResearchSearch();

        // --------------------------- //
        // subscribe overlay --------- //
        // --------------------------- //
        // add subscribe form 
        const subscribe = new Subscribe();

        // -------------------------------------- //
        // build out our subscribe overlay ------ //
        // -------------------------------------- //
        const subscribeOverlay = new Overlay({
            
            //set custom class for our modal
            modalSelector:".subscribing__modal",

            //set class name to fire off modal
            buttonSelector:".subscribe-overlay",

            // set content into modal title area
            title:subscribe.setTitle(),
            
            // set content into modal body area
            body:subscribe.setBody(),
            
            // callback
            callback:function(){

                // add event listener for submit button
                subscribe.submit();
                
            }
            
        });
        
        // -------------------------------------- //
        // research cards ----------------------- //
        // -------------------------------------- //
        const cards = new Cards();

        // --------------------------------- //
        // Report File Download Overlay ---- //
        // --------------------------------- //
        // report file
        const reports = new Reports();

        // -------------------------------------- //
        // search overlay ----------------------- //
        // -------------------------------------- //
        const reportsOverlay = new Overlay({

            //set custom class for our modal
            modalSelector:".reports__modal",

            //set class name to fire off modal
            buttonSelector:".--js-report-file",

            // add search title
            title:reports.setTitle(),
            
            // add form to body
            body: reports.setBody(),
            
            // callback
            callback:function(target){

                // reports submitted
                reports.submit(target);
                
            }

        });

        // -------------------------------------- //
        // Calculators File Download Overlay ---- //
        // -------------------------------------- //
        // report file
        const calculators = new Calculators();

        // -------------------------------------- //
        // search overlay ----------------------- //
        // -------------------------------------- //
        const calculatorsOverlay = new Overlay({

            //set custom class for our modal
            modalSelector:".calculators__modal",

            //set class name to fire off modal
            buttonSelector:".--js-calculator-file",

            // add search title
            title:calculators.setTitle(),
            
            // add form to body
            body: calculators.setBody(),
            
            // callback
            callback:function(target){

                // reports submitted
                calculators.submit(target);
                
            }

        });

        // ----------------------------------------------------- //
        // call more posts on subpages using the load button --- //
        // ----------------------------------------------------- //  
        const morePosts = new MorePosts();

        // ----------------------------------------------------- //
        // call more infographics on the infographics page ----- //
        // using the load button ------------------------------- //
        // ----------------------------------------------------- //  
        const infographics = new Infographics();

        // ---------------------------- //
        // Video Page Youtube List ---- //
        // ---------------------------- //
        const videos = new Videos();

        // ---------------------------- //
        // Data Page Functionalities -- //
        // ---------------------------- //
        const datas = new Data();

    }

};